module.exports = __webpack_public_path__ + "static/img/qiangchai2.5f271fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/qiangchai2.png
// module id = Y0OX
// module chunks = 24